// extracted by mini-css-extract-plugin
export var VenueHireFooterCTA = "VenueHireFooterCTA-module--VenueHireFooterCTA--d1c93";
export var description = "VenueHireFooterCTA-module--description--4eabc";
export var title = "VenueHireFooterCTA-module--title--f6b82";